import { useDispatch } from 'react-redux';
import { View16 } from 'ui/icons';
import { ActionMenuOption, AllowedActionMenuElements } from 'ui/actionMenu/types';
import { Goal } from 'modules/goals/types';
import { useMissionControlContext } from 'modules/missionControl/contexts/MissionControlContext';
import { addNegativeToast, addPositiveToast } from 'modules/toastContainer/utils';
import { ToastMessage } from 'modules/goals/lib/components/ToastMessage';
import { OverflowMenuItem } from './GoalCard.styled';
import { useUpdateGoalVisibilityMutation } from '../../../hooks/useUpdateGoalVisibilityMutation';

export const useGoalGoalCardOverflowMenuOptions = (goal: Goal): ActionMenuOption[] => {
  const dispatch = useDispatch();
  const {
    missionControlUserPreferencesQuery: { refetch: refetchMissionControlUserPreferences },
  } = useMissionControlContext();
  const { mutate: updateGoalVisibility } = useUpdateGoalVisibilityMutation({
    onSuccess: () => {
      dispatch(
        addPositiveToast(<ToastMessage name={goal.name} suffix=" goal hidden from homepage." />),
      );
      refetchMissionControlUserPreferences(); // NOTE: we will just use the response from `useUpdateGoalVisibilityMutation` in the future, instead of refetching the user preferences.
    },
    onError: () => {
      dispatch(
        addNegativeToast(
          <ToastMessage
            prefix="Unable to hide "
            name={goal.name}
            suffix=" goal from homepage. Please try again."
          />,
        ),
      );
    },
  });

  return [
    {
      id: 'hide-goal',
      content: (
        <OverflowMenuItem>
          <View16 />
          Hide goal
        </OverflowMenuItem>
      ),
      onClick: () =>
        updateGoalVisibility({
          goalId: goal.id,
          visibleToCurrentUser: false,
        }),
      as: AllowedActionMenuElements.Button,
      // appendDivider: true,
    },
    // TODO: This is not yet supported
    // {
    //   id: "archive-goal",
    //   label: "Archive goal",
    //   content: (
    //     <ArchiveMenuItem>
    //       <Archive16 />
    //       Archive
    //     </ArchiveMenuItem>
    //   ),
    //   onClick: noop,
    //   as: AllowedActionMenuElements.Button,
    // },
  ];
};
